/* @flow */
import { NEW_PRODUCT_CREATION } from '../../../../ActionsConst';
import {
  getSingleProductTypeAvailable,
  isSingleTemplateAvailable,
} from '../../../../services/product-type/ProductTypeService';
import { requestCreationTemplates, clearCreationTemplates } from '../templates/TemplatesActions';

import type { ProductSizes } from '../../../../../api/types/ProductSizes';
import type { Action } from '../../../../ActionsConst';

export type Dispatch = (Action) => void;

export type SingleProductSettingsAction = Action & {
  type: NEW_PRODUCT_CREATION,
  load: {
    isSingleProductType: boolean,
    isLoading: boolean,
    start: number,
  },
};

export const newProductCreationSettingsAction = (
  singleProductTypeId: null | string,
  requestTemplates: boolean,
): SingleProductSettingsAction => {
  const isSingleProductType = singleProductTypeId !== null;
  const isLoading = requestTemplates === true;

  return {
    type: NEW_PRODUCT_CREATION,
    load: {
      isSingleProductType,
      isLoading,
      start: 0,
    },
  };
};

// TODO rename this to something declaring that is a single product redirect logic
export const configureCreationSettings = (productSizesAvailable: ProductSizes, apiUrl: string) => {
  return (dispatch: Dispatch) => {
    const singleProductTypeId = getSingleProductTypeAvailable(productSizesAvailable);
    // There is only 1 template for all product types ==> Skip to pixel
    // OR
    // There is 1 product type with more than 1 template ==> Jump product selection, allow template selection
    const requestTemplates = isSingleTemplateAvailable(productSizesAvailable) || singleProductTypeId !== null;

    dispatch(newProductCreationSettingsAction(singleProductTypeId, requestTemplates));

    if (requestTemplates) {
      dispatch(clearCreationTemplates());
      requestCreationTemplates({
        productTypeId: singleProductTypeId,
        apiUrl,
      })(dispatch);
    }
  };
};
